module.exports = __webpack_public_path__ + "static/plant-care-icon-70px-becd57bc5980a736c61b0afd7a95be7e.svg";